import { IPublicAccountPagedRequest } from '../../../../model/apm/public-account/request/public-account-paged-request';
import { IPublicAccountResponse } from '../../../../model/apm/public-account/response/public-account-response';
import { IPublicAccountCategoryResponse } from '../../../../model/apm/public-account/response/public-account-category-response';
import { ILookupResponse } from '../../../../model/apm/base/lookup-response';
import { IPortalDocumentResponse } from '../../../../model/apm/document/portal-document-response';

export type PublicAccountSearchState = {
    parameters: IPublicAccountPagedRequest;
    searchTrigger: number;
    categories: IPublicAccountCategoryResponse[];
    documentTypes: ILookupResponse[];
    // Anexos ficam separados do registro para não reiniciar o formulário a cada envio
    drawer: { open: boolean; publicAccount?: IPublicAccountResponse; files: IPortalDocumentResponse[] };
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
    setLookups = 'setLookups',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
    setDrawerFiles = 'setDrawerFiles',
}

export const PublicAccountSearchReducer = (state: PublicAccountSearchState, action: any): PublicAccountSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        case ACTION_TYPES.setLookups:
            return { ...state, ...payload };
        case ACTION_TYPES.openDrawer:
            return { ...state, drawer: { open: true, publicAccount: payload, files: payload?.files || [] } };
        case ACTION_TYPES.closeDrawer:
            return { ...state, drawer: { open: false, files: [] } };
        case ACTION_TYPES.setDrawerFiles:
            return { ...state, drawer: { ...state.drawer, files: payload } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
